const common = {
  // Nav
  "nav.guides": "ホーム",
  "nav.clientSdk": "機能",
  "nav.serverApi": "ドキュメント",
  "nav.download": "ダウンロード",
  "nav.android": "Android",
  "nav.ios": "iOS",
  "nav.pc": "Web版",
  "nav.github": "GitHub",
  "nav.blog": "ブログ",

  // Hero
  "hero.badge": "オープンソースメッセージング",
  "hero.title1": "Build with",
  "hero.title2": "TupIM",
  "hero.desc": "TupIMはIM技術の専門家が開発したオープンソースのインスタントメッセージングコンポーネントです。IMサーバーとクライアントSDKを含み、軽量で柔軟、拡張が容易です。プライベートデプロイでデータのセキュリティを確保。",
  "hero.download": "ダウンロード",
  "hero.stat.devs": "開発者",
  "hero.stat.msgs": "メッセージ/日",
  "hero.badge2.title": "エンドツーエンド暗号化",
  "hero.badge2.desc": "メッセージは安全に保護されます",

  // Features
  "features.label": "コア機能",
  "features.title": "コミュニケーションに必要なすべて",
  "features.subtitle": "TupIMはメッセージング、通話、グループ、ファイルなど、完全なインスタントメッセージングソリューションを提供します。",

  "feat.msg.title": "インスタントメッセージ",
  "feat.msg.desc": "テキスト、絵文字、画像、音声、ビデオメッセージをミリ秒単位で配信。",
  "feat.call.title": "音声・ビデオ通話",
  "feat.call.desc": "一対一またはグループの高品質音声・ビデオ通話、画面共有対応。",
  "feat.group.title": "グループチャット",
  "feat.group.desc": "数千人のメンバーをサポートするグループを作成・管理。",
  "feat.file.title": "ファイル転送",
  "feat.file.desc": "ファイル、写真、動画を高速・安全に転送。再開機能付き。",
  "feat.encrypt.title": "エンドツーエンド暗号化",
  "feat.encrypt.desc": "すべてのメッセージがE2E暗号化。秘密鍵はデバイスのみに保存。",
  "feat.notify.title": "プッシュ通知",
  "feat.notify.desc": "全プラットフォームで即時プッシュ、重要なメッセージを見逃さない。",
  "feat.cross.title": "PC+APP対応",
  "feat.cross.desc": "1つのSDKでWeb、Android、iOSをカバー。",
  "feat.private.title": "プライベートデプロイ",
  "feat.private.desc": "自社サーバーへのデプロイに対応。データを完全に自己管理。",
  "feat.selfhost.title": "高パフォーマンス",
  "feat.selfhost.desc": "Goで構築。シングルノードで数百万の同時接続をサポート。",

  "features.sdk.title": "マルチプラットフォームSDK対応",
  "features.sdk.desc": "どんな技術スタックでも、TupIMのSDKが対応します",

  // Api hero section
  "api.hero.title1": "Build with",
  "api.hero.title2": "TupIM",
  "api.hero.desc": "TupIMはIM技術の専門家が開発したオープンソースのインスタントメッセージングコンポーネントです。プライベートデプロイに対応し、データのセキュリティを確保します。",
  "api.hero.btn.start": "開始する",
  "api.hero.btn.guide": "スタートガイド",

  // Api / Deploy section
  "api.open.title": "完全オープンソース",
  "api.open.desc": "TupIMサーバーとすべてのSDKはMITライセンスでGitHubに公開されています。",
  "api.open.contrib": "コントリビューター",
  "api.open.btn": "GitHubで見る",
  "api.deploy.title": "簡単セルフホスト",
  "api.deploy.desc": "数分で自社サーバーにTupIMをデプロイ。サードパーティ依存なし。",
  "api.deploy.f1": "Docker Composeワンクリックデプロイ",
  "api.deploy.f2": "Kubernetesクラスターデプロイ対応",
  "api.deploy.f3": "完全なモニタリング・ログシステム",
  "api.deploy.btn": "デプロイドキュメントを読む",

  // Help
  "help.title": "何かお手伝いできることはありますか？",
  "help.demo.title": "デモを見る",
  "help.demo.desc": "アプリをダウンロードしてテストするか、デモサイトにアクセスできます。",
  "help.demo.link": "今すぐ →",
  "help.support.title": "サポート",
  "help.support.desc": "TupIMのコードリポジトリで問題を見つけたり提出したりできます。",
  "help.support.link": "今すぐ →",
  "help.faq.title": "よくある質問",
  "help.faq.desc": "FAQセクションで一般的な質問の回答を見つけてください。",
  "help.faq.link": "FAQを見る →",

  // Community
  "community.title": "コミュニティに参加",
  "community.desc": "成長中のコミュニティと交流して、最新情報やサポートを得ましょう。",
  "community.slack": "Slack →",

  // Download page
  "download.android.badge": "Androidアプリ",
  "download.android.title": "TupIM Android版をダウンロード",
  "download.android.desc": "テキスト、音声、ビデオ通話、グループチャット、ファイル転送など豊富な機能を持つAndroidアプリ。",
  "download.android.version": "最新バージョン",
  "download.android.size": "パッケージサイズ",
  "download.android.require": "システム要件",
  "download.android.require.val": "Android 5.0以上",
  "download.android.btn": "APKをダウンロード",
  "download.android.qr": "QRコードでダウンロード",
  "download.android.qr.desc": "スマートフォンのカメラかQRスキャナーでスキャン",
  "download.android.tip": "ダウンロード後、不明なソースからのインストールを許可してください",
  "download.android.cta.title": "今すぐ始める",
  "download.android.cta.desc": "無料ダウンロード — 安全で高性能なインスタントメッセージングを体験",

  "download.ios.badge": "iOSアプリ",
  "download.ios.title": "TupIM iOS版をダウンロード",
  "download.ios.desc": "iPhoneとiPad向けのインスタントメッセージングアプリ。すべてのコア機能をサポート。",
  "download.ios.version": "最新バージョン",
  "download.ios.size": "パッケージサイズ",
  "download.ios.require": "システム要件",
  "download.ios.require.val": "iOS 13.0以上",
  "download.ios.btn": "App Storeでダウンロード",
  "download.ios.btn2": "TestFlightベータ",
  "download.ios.qr": "QRコードでダウンロード",
  "download.ios.qr.desc": "iPhoneカメラでスキャンしてApp Storeへ",
  "download.ios.tip": "iOS 15.0以上のiPhone・iPadに対応",
  "download.ios.cta.title": "今すぐ始める",
  "download.ios.cta.desc": "App Storeで無料ダウンロード、またはTestFlightで最新機能を先行体験",

  // PC / Web version
  "download.pc.badge": "ブラウザ版",
  "download.pc.title": "TupIM Webブラウザ版",
  "download.pc.desc": "インストール不要。Webブラウザからいつでもどこでもアクセスして、完全なインスタントメッセージング機能をお楽しみください。",
  "download.pc.btn.open": "今すぐ開く",
  "download.pc.tip": "無料・インストール不要。すべてのデバイスと同期。",
  "download.pc.features.title": "コア機能",
  "download.pc.features.subtitle": "ブラウザで使えるフル機能のコミュニケーション体験",
  "download.pc.screenshots.title": "スクリーンショット",
  "download.pc.ss.chats": "チャット",
  "download.pc.ss.call": "ビデオ通話",
  "download.pc.ss.group": "グループチャット",
  "download.pc.ss.file": "ファイル管理",
  "download.pc.cta.title": "Webブラウザで始める",
  "download.pc.cta.desc": "インストール不要、どのブラウザからでもすぐに使えます",
  "download.pc.cta.btn": "ブラウザで開く",
  "download.pc.browser.support": "対応ブラウザ",

  // Download features
  "download.feature.msg": "インスタントメッセージ",
  "download.feature.msg.desc": "テキスト、絵文字、画像、音声、ビデオなどのメッセージタイプに対応",
  "download.feature.call": "音声・ビデオ通話",
  "download.feature.call.desc": "一対一またはグループの音声・ビデオ通話、クリアでスムーズ",
  "download.feature.group": "グループチャット",
  "download.feature.group.desc": "グループを作成・管理、数千人のメンバーをサポート",
  "download.feature.file": "ファイル転送",
  "download.feature.file.desc": "ファイル、写真、動画の高速・安全な転送",
  "download.feature.encrypt": "エンドツーエンド暗号化",
  "download.feature.encrypt.desc": "すべてのメッセージがE2E暗号化されプライバシーを保護",
  "download.feature.notify": "プッシュ通知",
  "download.feature.notify.desc": "重要なメッセージの即時プッシュ、見逃しゼロ",
  "download.feature.shortcut": "キーボードショートカット",
  "download.feature.shortcut.desc": "豊富なショートカットでデスクトップの生産性を向上",

  // Download Section (homepage)
  "dl.label": "ダウンロード",
  "dl.title": "マルチプラットフォーム対応",
  "dl.subtitle": "Android、iOS、すべての主要ブラウザで利用可能。すべてのデバイスでメッセージがシームレスに同期。",
  "dl.sync": "すべて無料。すべてのデバイスでリアルタイム同期。",
  "dl.android.title": "Android版",
  "dl.android.desc": "Androidスマートフォン・タブレット向けの全機能メッセージングアプリ。",
  "dl.android.req": "Android 5.0+",
  "dl.android.btn": "Androidでダウンロード",
  "dl.ios.title": "iPhone & iPad",
  "dl.ios.desc": "iPhoneとiPad向けのネイティブiOS体験。スムーズで高速。",
  "dl.ios.req": "iOS 15.0+",
  "dl.ios.btn": "iOSでダウンロード",
  "dl.pc.title": "ブラウザ版",
  "dl.pc.desc": "インストール不要。Webブラウザからすぐにアクセス。",
  "dl.pc.req": "任意のブラウザ",
  "dl.pc.btn": "ブラウザで開く",

  // Showcase
  "showcase.label": "詳細",
  "showcase.title": "すべての機能はあなたのために",
  "showcase.subtitle": "インスタントメッセージングからビデオ通話まで、すべてのモジュールが最高のコミュニケーション体験を提供。",
  "showcase.msg.title": "インスタントメッセージ",
  "showcase.msg.tag": "メッセージング",
  "showcase.msg.desc": "ミリ秒単位の配信とリッチメディアメッセージに対応",
  "showcase.msg.p1": "テキスト、絵文字、画像、音声、動画など20種類以上のメッセージタイプ",
  "showcase.msg.p2": "既読確認 — 誰が読んだか確認できます",
  "showcase.msg.p3": "メッセージの取り消し、引用返信、@メンション対応",
  "showcase.msg.p4": "オフラインメッセージ自動同期",
  "showcase.call.title": "音声・ビデオ通話",
  "showcase.call.tag": "通話",
  "showcase.call.desc": "安定した高品質HD通話",
  "showcase.call.p1": "一対一・多人数グループ音声・ビデオ通話に対応",
  "showcase.call.p2": "画面共有機能内蔵",
  "showcase.call.p3": "アダプティブビットレートで安定した通話品質",
  "showcase.call.p4": "通話録音機能",
  "showcase.group.title": "グループチャット",
  "showcase.group.tag": "グループ",
  "showcase.group.desc": "数千人をサポートする柔軟なグループ管理",
  "showcase.group.p1": "1グループ最大1,000人",
  "showcase.group.p2": "多段階管理者ロールと詳細な権限設定",
  "showcase.group.p3": "グループアナウンス、共有ファイル、グループアルバム内蔵",
  "showcase.group.p4": "ミュート、キック、参加承認などの完全なグループ管理",
  "showcase.security.title": "エンドツーエンド暗号化",
  "showcase.security.tag": "プライバシー",
  "showcase.security.desc": "E2E暗号化 — 秘密鍵はデバイスを離れない",
  "showcase.security.p1": "すべてのメッセージが完全にE2E暗号化 — サーバーは読めない",
  "showcase.security.p2": "閲覧後自動削除機能",
  "showcase.security.p3": "セルフホスト — データは自社サーバーに保存",
  "showcase.security.p4": "定期的なサードパーティセキュリティ監査",

  // Pricing
  "pricing.label": "料金プラン",
  "pricing.title": "あなたに合ったプランを選ぶ",
  "pricing.subtitle": "個人開発者、成長チーム、大企業まで — TupIMはすべての規模に対応したプランを用意しています。",
  "pricing.popular": "最も人気",
  "pricing.includes": "含まれる機能",
  "pricing.note": "すべてのプランに7日間の無料トライアルがあります。クレジットカード不要。",
  "pricing.starter.name": "スターター",
  "pricing.starter.tag": "個人 / 小チーム",
  "pricing.starter.desc": "個人開発者や小規模アプリがTupIMのコア機能を体験するのに最適。",
  "pricing.starter.cta": "無料で始める",
  "pricing.starter.f1": "最大500アクティブユーザー",
  "pricing.starter.f2": "テキスト・画像・音声メッセージ",
  "pricing.starter.f3": "一対一の音声・ビデオ通話",
  "pricing.starter.f4": "基本グループ（最大50人）",
  "pricing.starter.f5": "コミュニティサポート",
  "pricing.starter.m1": "マルチパーティグループ通話",
  "pricing.starter.m2": "プライベートデプロイ",
  "pricing.starter.m3": "専任技術サポート",
  "pricing.pro.name": "プロ",
  "pricing.pro.tag": "成長チーム",
  "pricing.pro.desc": "急成長する製品・チーム向け。フル機能セットで数百万ユーザーに対応。",
  "pricing.pro.cta": "営業に連絡",
  "pricing.pro.f1": "最大10,000アクティブユーザー",
  "pricing.pro.f2": "すべてのリッチメディアメッセージ",
  "pricing.pro.f3": "マルチパーティグループ通話",
  "pricing.pro.f4": "最大1,000人のグループ",
  "pricing.pro.f5": "画面共有・通話録音",
  "pricing.pro.f6": "E2E暗号化・閲覧後削除",
  "pricing.pro.m1": "プライベートデプロイ",
  "pricing.enterprise.name": "エンタープライズ",
  "pricing.enterprise.tag": "大企業",
  "pricing.enterprise.desc": "大規模アプリと企業向け。完全セルフホスト、完全なデータ管理。",
  "pricing.enterprise.cta": "見積もりを取得",
  "pricing.enterprise.f1": "無制限のアクティブユーザー",
  "pricing.enterprise.f2": "すべての機能、制限なし",
  "pricing.enterprise.f3": "プライベートデプロイ・ソースコードライセンス",
  "pricing.enterprise.f4": "Kubernetesクラスター高可用性",
  "pricing.enterprise.f5": "SLA 99.99%稼働率保証",
  "pricing.enterprise.f6": "専任技術コンサルタント",
  "pricing.enterprise.f7": "カスタム機能開発",

  // Docs page
  "docs.title": "ドキュメント",
  "docs.group.start": "入門",
  "docs.group.core": "コア機能",
  "docs.group.dev": "開発者ガイド",
  "docs.nav.introduction": "はじめに",
  "docs.nav.quickstart": "クイックスタート",
  "docs.nav.messaging": "インスタントメッセージ",
  "docs.nav.calls": "音声・ビデオ通話",
  "docs.nav.groups": "グループ管理",
  "docs.nav.encryption": "セキュリティと暗号化",
  "docs.nav.sdk": "SDK統合",
  "docs.nav.deployment": "セルフホスト",
  "docs.nav.api": "APIリファレンス",
  "docs.toc": "目次",
  "docs.copied": "コピー済み",
  "docs.copy": "コピー",
  "docs.install": "インストール",
  "docs.init": "初期化",

  // Docs - Server group
  "docs.group.server": "サーバー",
  "docs.nav.sfu": "SFU 帯域幅計算",
  "docs.sfu.title": "SFUベースのビデオ会議の帯域幅計算方法",
  "docs.sfu.intro": "SFU（選択的転送ユニット）アーキテクチャでは、各参加者は自分のストリームを SFU サーバーにアップロードし、サーバーは他の参加者のストリームを選択的に転送します。本文では SFU ベースの帯域幅要件の見積もり方を説明します。",
  "docs.sfu.arch.title": "SFU アーキテクチャの概要",
  "docs.sfu.arch.desc": "MCUと異なり、SFU はストリームをミキシングしません。各参加者は N-1 本のダウンリンクと 1 本のアップリンクを持ちます。これにより大規模なグループ通話に最適です。",
  "docs.sfu.formula.title": "帯域幅計算式",
  "docs.sfu.formula.uplink": "アップリンク（ユーザーごと）: 1 本のビデオストリームアップロード",
  "docs.sfu.formula.downlink": "ダウンリンク（ユーザーごと）: (N-1) 本のビデオストリームダウンロード",
  "docs.sfu.formula.total": "サーバー総帯域幅 = N × アップリンクビットレート + N × (N-1) × ダウンリンクビットレート",
  "docs.sfu.params.title": "参考ビットレートパラメータ",
  "docs.sfu.params.hd": "HD（720p）: アップ ~1.5 Mbps / ダウン ~1.2 Mbps",
  "docs.sfu.params.sd": "SD（480p）: アップ ~0.8 Mbps / ダウン ~0.6 Mbps",
  "docs.sfu.params.ld": "低画質（240p）: アップ ~0.3 Mbps / ダウン ~0.25 Mbps",
  "docs.sfu.example.title": "計算例",
  "docs.sfu.example.desc": "以下の例では HD 品質（720p）、アップリンク 1.5 Mbps、ダウンリンク 1.2 Mbps を想定しています。",
  "docs.sfu.note.title": "重要な注意事項",
  "docs.sfu.note.1": "プロトコルヘッダー、再送信、RTCP 制御トラフィック用に約 20% のオーバーヘッドを加算してください。",
  "docs.sfu.note.2": "シミュルキャストを有効にすると、SFU が受信者ごとに適応的にストリーム品質を選択できます。",
  "docs.sfu.note.3": "音声ストリームは通常、参加者ごとに 50–100 kbps 追加されます。",
  "docs.sfu.note.4": "画面共有ストリームは追加で 2–4 Mbps のアップリンク帯域幅が必要な場合があります。",

  // Footer
  "footer.tagline": "TupIM\u00a0プライバシーを守る安全なメッセージング、グループチャット、暗号化機能",
  "footer.col.product": "製品",
  "footer.col.developer": "開発者",
  "footer.col.company": "会社",
  "footer.link.features": "機能",
  "footer.link.download": "ダウンロード",
  "footer.link.changelog": "更新履歴",
  "footer.link.docs": "ドキュメント",
  "footer.link.api": "APIリファレンス",
  "footer.link.github": "GitHub",
  "footer.link.about": "会社概要",
  "footer.link.blog": "ブログ",
  "footer.link.contact": "お問い合わせ",
  "footer.copyright": "© 2024 TupIM. All rights reserved.",
  "footer.lang.zh": "繁體中文",
  "footer.lang.en": "English",

  // About page
  "about.badge": "会社概要",
  "about.hero.title": "次世代オープンソースメッセージングインフラの構築",
  "about.hero.desc": "TupIMはIM技術のプロフェッショナルエンジニアによって設立され、すべての開発者が最小限のコストでエンタープライズグレードのインスタントメッセージアプリを構築できるように致力しています。",
  "about.hero.cta1": "お問い合わせ",
  "about.hero.cta2": "GitHubで見る",
  "about.stat.devs": "グローバル開発者",
  "about.stat.msgs": "メッセージ / 日",
  "about.stat.stars": "GitHub Stars",
  "about.stat.countries": "国々",
  "about.mission.label": "ミッション & ビジョン",
  "about.mission.title": "すべてのアプリに強力なメッセージング機能が必要です",
  "about.mission.p1": "IM技術は長い間大手統に独占されてきました。TupIMはこのサイクルを打破るために作られました。",
  "about.mission.p2": "完全なオープンソースIMソリューションを提供—サーバー、Web SDK、iOS SDK、Android SDK。",
  "about.mission.p3": "私たちのビジョン：世界中で最も信頼されるオープンソースメッセージングインフラになること。",
  "about.values.label": "コアバリュー",
  "about.values.title": "私たちが信じること",
  "about.values.subtitle": "これらの価値観がすべての技術的決定と製品方向を導いています。",
  "about.value.opensource.title": "オープン & 透明性",
  "about.value.opensource.desc": "すべてのコードがMITライセンスの下でGitHubに完全公開されています。",
  "about.value.privacy.title": "プライバシーファースト",
  "about.value.privacy.desc": "エンドツーエンド暗号化は標準で、オプションではありません。",
  "about.value.performance.title": "極限のパフォーマンス",
  "about.value.performance.desc": "Goベースの高性能サーバーは単一ノードで数百万の同時接続を処理できます。",
  "about.value.community.title": "コミュニティドリブン",
  "about.value.community.desc": "製品方向はコミュニティによって決められます。",
  "about.value.developer.title": "開発者体験",
  "about.value.developer.desc": "豊富なドキュメント、包括的なデモ、クリーンなSDK APIで統合を尽くスムーズに。",
  "about.value.enterprise.title": "エンタープライズ準備完了",
  "about.value.enterprise.desc": "Kubernetesクラスター、マルチリージョンHA、完全なモニタリングとアラートで本番環境に完璧。",
  "about.timeline.label": "マイルストーン",
  "about.timeline.title": "私たちが歩んできたすべての歩み",
  "about.timeline.2020q1.date": "2020年Q1",
  "about.timeline.2020q1.title": "プロジェクト開始",
  "about.timeline.2020q1.desc": "コアチーム結成、Goベースの高性能IMサーバーアーキテクチャの研究と設計開始。",
  "about.timeline.2020q3.date": "2020年Q3",
  "about.timeline.2020q3.title": "初のオープンソースリリース",
  "about.timeline.2020q3.desc": "GitHubにOpenIM Server v1.0公開、初週に500+スター獲得。",
  "about.timeline.2021q2.date": "2021年Q2",
  "about.timeline.2021q2.title": "全プラットフォームSDKカバレッジ",
  "about.timeline.2021q2.desc": "iOS、Android、Web SDK同時リリース。",
  "about.timeline.2022q1.date": "2022年Q1",
  "about.timeline.2022q1.title": "GitHub 10,000スター達成",
  "about.timeline.2022q1.desc": "GitHubスター10K突破、GoOSS IMの中で最も人気のプロジェクトの一つに。",
  "about.timeline.2022q4.date": "2022年Q4",
  "about.timeline.2022q4.title": "エンタープライズエディションリリース",
  "about.timeline.2022q4.desc": "プライベートデプロイ、専属サポート、SLA保証付きエンタープライズプラン発表。",
  "about.timeline.2023q2.date": "2023年Q2",
  "about.timeline.2023q2.title": "音声＆ビデオモジュールリリース",
  "about.timeline.2023q2.desc": "WebRTCベースの高画HD通話モジュール正式統合。",
  "about.timeline.2024q1.date": "2024年Q1",
  "about.timeline.2024q1.title": "グローバル開発者50,000名突破",
  "about.timeline.2024q1.desc": "世界80か国以上でTupIMを利用する開発者が50K人超え。",
  "about.timeline.2024q4.date": "2024年Q4",
  "about.timeline.2024q4.title": "TupIMブランドアップグレード",
  "about.timeline.2024q4.desc": "TupIMにブランド全面アップグレード、新ウェブサイトとドキュメントシステムをリリース。",
  "about.team.label": "チーム",
  "about.team.title": "TupIMを支える人々",
  "about.team.subtitle": "オープンソースを愛し、IM技術に情熱を注ぐエンジニアグループ。",
  "about.team.ceo.name": "Alex Chen",
  "about.team.ceo.role": "CEO & Co-Founder",
  "about.team.ceo.bio": "大手テック企業の元IMアーキテクト、10年以上の経験。",
  "about.team.cto.name": "Kevin Wang",
  "about.team.cto.role": "CTO & Co-Founder",
  "about.team.cto.bio": "GoコアコントリビューターかつOpenIM Serverのリードアーキテクト。",
  "about.team.lead.name": "Sophie Lin",
  "about.team.lead.role": "Lead Engineer",
  "about.team.lead.bio": "Web SDKとフロントエンドアーキテクチャを担当するフルスタックエンジニア。",
  "about.team.sdk.name": "James Zhang",
  "about.team.sdk.role": "Mobile SDK Lead",
  "about.team.sdk.bio": "iOS & Androidデュアルエキスパート、モバイルSDK設計をリード。",
  "about.team.infra.name": "David Liu",
  "about.team.infra.role": "Infrastructure Lead",
  "about.team.infra.bio": "Kubernetesスペシャリスト、TupIMのクラウドネイティブデプロイメントソリューションを担当。",
  "about.team.design.name": "Emma Wu",
  "about.team.design.role": "Product Design Lead",
  "about.team.design.bio": "開発者ツールに特化したUXスペシャリスト。",

  // Contact page
  "contact.badge": "お問い合わせ",
  "contact.hero.title": "ご質問はありますか？私たちがお手伝いします。",
  "contact.hero.desc": "技術的な問題、ビジネスお問い合わせ、メディア要請など—最適なチャンネルを選んでお連絡ください。",
  "contact.channel.support.title": "技術サポート",
  "contact.channel.support.desc": "バグ、SDKの問題、またはデプロイの質問がありますか？GitHubイシューを開くか、Slackコミュニティに参加してください。",
  "contact.channel.support.link1": "GitHubイシューを開く",
  "contact.channel.support.link2": "Slackコミュニティに参加",
  "contact.channel.business.title": "ビジネスお問い合わせ",
  "contact.channel.business.desc": "エンタープライズプラン、商業ライセンス、カスタム開発にご興味ありますか？",
  "contact.channel.business.link1": "ビジネスメールを送る",
  "contact.channel.business.link2": "WeChatコンサルティング",
  "contact.channel.media.title": "メディア & PR",
  "contact.channel.media.desc": "インタビュー、レビュー、コラボイベントなど？",
  "contact.channel.media.link1": "メディア連絡メール",
  "contact.channel.media.link2": "Twitterでフォロー",
  "contact.channel.community.title": "オープンソースコミュニティ",
  "contact.channel.community.desc": "オープンソースコミュニティに参加して、世界中の開発者と交流しましょう。",
  "contact.channel.community.link1": "Slackに参加",
  "contact.channel.community.link2": "GitHubでフォロー",
  "contact.response.note": "一般的な回答時間: 技術的な問題24時間以内 · ビジネス問い合わせ1-2営業日 · メディア要請2-3営業日",
  "contact.faq.label": "FAQ",
  "contact.faq.title": "よくある質問",
  "contact.faq.f1.q": "TupIMは完全無料ですか？",
  "contact.faq.f1.a": "はい—TupIMサーバーとすべてのクライアントSDKはMITライセンスの下で完全オープンソースかつ無料です。",
  "contact.faq.f2.q": "TupIMをすくyに始めるには？",
  "contact.faq.f2.a": "クイックスタートドキュメントを確認してください。Docker Composeで 5分以内にサーバーをデプロイできます。",
  "contact.faq.f3.q": "データのセキュリティとプライバシーはどう保証されますか？",
  "contact.faq.f3.a": "TupIMはプライベートデプロイをサポート—すべてのデータはあなたのサーバーに存在します。",
  "contact.faq.f4.q": "どの程度の同時接続数をサポートしますか？",
  "contact.faq.f4.a": "TupIM ServerのGoアーキテクチャは単一ノードで100万以上の同時接続を処理できます。",
  "contact.faq.f5.q": "エンタープライズライセンスはどうすれば取得できますか？",
  "contact.faq.f5.a": "ビジネスメールまたはWeChatで営業チームに連絡し、ビジネス規模と要件をお知らせください。",

  "nav.about": "会社概要",
  "nav.contact": "お問い合わせ",

  // Page title
  "page.title": "TupIM — プライバシーを守るメッセージング、グループチャット、暗号化機能",
};

export default common;